import { Divider, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCase } from "../../context/CaseContext";
import { IssueRelation } from "../../shared/CaseModel";
import { SegmentedControl } from "../general/SegmentedControl";

const RELATIONS = ["And", "Or", "Xor"] as const;

/**
 * How an issue combines with the one after it, on a rule between the two.
 */
export const IssueRelationSelector = ({
  selected,
  onRelationClicked,
}: {
  selected: IssueRelation;
  onRelationClicked: (relation: IssueRelation) => void;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "case.claims.issues.relations",
  });
  const { readOnly } = useCase();

  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
      <Divider sx={{ width: 24 }} />
      <SegmentedControl
        ariaLabel={t("label")}
        disabled={readOnly}
        value={RELATIONS[selected]}
        options={RELATIONS.map((relation) => ({
          value: relation,
          label: t(`name.${relation}`),
          title: t(`hint.${relation}`),
        }))}
        onChange={(relation) => onRelationClicked(IssueRelation[relation])}
      />
      <Divider sx={{ flex: 1 }} />
    </Stack>
  );
};
